import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles((theme) => ({
	root: {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: theme.zIndex.drawer + 2,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: 26,
		backgroundColor: "#f0f2f5",
	},
	logo: {
		width: 260,
		maxWidth: "62%",
		objectFit: "contain",
	},
	spinner: {
		color:
			(theme.palette && theme.palette.primary && theme.palette.primary.main) ||
			"#2563EB",
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	const ctx = useContext(ColorModeContext) || {};
	const cm = ctx.colorMode || ctx || {};
	const logo = cm.appLogoLoading || cm.appLogoLight || null;

	return (
		<div className={classes.root}>
			{logo ? (
				<img src={logo} alt="Carregando" className={classes.logo} />
			) : null}
			<CircularProgress className={classes.spinner} size={42} thickness={4} />
		</div>
	);
};

export default BackdropLoading;
